import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';
import { components } from 'api/types';
import RunState from 'types/RunState';

type WorkflowSummary = components['schemas']['WorkflowSummary'];

function updateStateInStore(projectId: string, runId: string, summary: WorkflowSummary) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      const run = state.runsAsync.data?.items.find((run) => run.id === runId);
      if (run) {
        run.state = summary.state as RunState;
        run.task_state_count = summary.task_state_count;
      }
      const details = state.runDetailsAsyncMap[runId];
      if (details?.data) {
        details.data.state = summary.state as RunState;
      }
    }),
  );
}

export default function cancelRun(runId: string) {
  const projectId = getProjectId();
  if (!projectId) return Promise.reject(new Error('No project ID'));

  return api
    .post(`projects/${projectId}/workflows/${runId}/operations`, {
      json: { type: 'CANCEL' },
    })
    .json<WorkflowSummary>()
    .then(
      (summary) => {
        updateStateInStore(projectId, runId, summary);
      },
      (error) => {
        Sentry.captureException(error);
        throw error;
      },
    );
}
